import { render, staticRenderFns } from "./BlipTagsMetricsTable.vue?vue&type=template&id=a111d386&scoped=true&"
import script from "./BlipTagsMetricsTable.vue?vue&type=script&lang=js&"
export * from "./BlipTagsMetricsTable.vue?vue&type=script&lang=js&"
import style0 from "./BlipTagsMetricsTable.vue?vue&type=style&index=0&id=a111d386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a111d386",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VDataTable})
